var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dropdown-container" },
    [
      _c("show-at", { attrs: { breakpoint: "small" } }, [
        _c("img", {
          staticClass: "menu-icon",
          attrs: { src: require("@/assets/icn-user.svg") }
        })
      ]),
      _vm._v(" "),
      _c("show-at", { attrs: { breakpoint: "mediumAndAbove" } }, [
        _c("div", [_vm._v(_vm._s(this.userName)), _c("dropdown-arrow")], 1)
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "dropdown" }, [
        _c(
          "li",
          [
            _c(
              "x-button",
              {
                staticClass: "profile-link full-width",
                attrs: { to: { name: "user-infos" } }
              },
              [
                _c("ic-profile"),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("common.my-profile")) +
                    "\n      "
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.$featureFlag("cAssistanceUrl") && !_vm.isEsrSsoRestriction
          ? _c(
              "li",
              [
                _c(
                  "x-button",
                  {
                    staticClass: "assistance-button full-width",
                    attrs: {
                      href: _vm.$featureValue("cAssistanceUrl"),
                      target: "_blank"
                    }
                  },
                  [
                    _c("ic-help"),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("common.assistance")) +
                        "\n      "
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.isEsrSsoRestriction
          ? _c(
              "li",
              [
                _c(
                  "x-button",
                  {
                    staticClass: "contractual-documents-button full-width",
                    attrs: { href: _vm.siteUrlLandingPage, target: "_blank" }
                  },
                  [
                    _c("ic-download"),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("common.contractual-documents")) +
                        "\n      "
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "x-button",
              {
                staticClass: "private-button full-width",
                on: { click: _vm.switchPrivateMode }
              },
              [
                _c("ic-private"),
                _vm._v(" "),
                _c("span", {
                  staticClass: "private-mode",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        `common.private-mode.${_vm.privateMode ? "on" : "off"}`
                      )
                    )
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isAdvisor ? _c("li", [_c("logout-user")], 1) : _vm._e(),
        _vm._v(" "),
        !_vm.isAdvisor
          ? _c("li", [
              _c("div", { staticClass: "last-connection" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("common.last-connection")))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.lastConnection))])
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }